export default "__VITE_ASSET__b3c87496__"